import { z } from 'my-zod'
import { enumOptionsToObject } from '../../internal'

export const polarisRentalProductAssociatedAddOnProductDisplayMode = ['WithCounter', 'Hidden'] as const

export const polarisRentalProductAssociatedAddOnProductDisplayModeTypes = enumOptionsToObject(
  polarisRentalProductAssociatedAddOnProductDisplayMode
)

export const polarisRentalProductAssociatedAddOnProductsModel = z.object({
  rentalProductId: z.string().min(1),
  addOnProductId: z.string().min(1),
  minQuantityPerOrder: z.number().nullable(),
  maxQuantityPerRider: z.number().nullable(), // @todo change to min(1)
  displayMode: z.enum(polarisRentalProductAssociatedAddOnProductDisplayMode)
})

export type polarisRentalProductAssociatedAddOnProducts = z.infer<typeof polarisRentalProductAssociatedAddOnProductsModel>
